import { LOCALES } from 'fractals'

export const HEADING = {
  [LOCALES.en]: 'Programs',
  [LOCALES.ru]: 'Программы',
  [LOCALES.uz]: 'Dasturlar',
  [LOCALES.kk]: 'Бағдарламалар'
} as const
